// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Td7e","top":"styles_top__2UP7G","left":"styles_left__q-Dsp","description":"styles_description__3KfeU"};